var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isMobile)?_c('informasi-lainnya-desktop-detail'):_c('informasi-lainnya-mobile-detail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }